<template>
    <div>
        <ul>
            <li v-for="session in sessions" v-text="session.title"></li>
        </ul>
    </div>
</template>

<script>
    export default {
        name: "SessionList",


        data() {
            return {
                sessions: [],
                interval: null,
            }
        },


        created() {
            axios.get('/sessions/vue').then(response => (this.sessions = response.data));
            /*
            this.loadData();
            this.interval = setInterval(function () {
                this.loadData();
            }.bind(this), 3000);

             */
        },

        methods: {
            loadData: function () {
                axios.get('/sessions/vue').then(response => (this.sessions = response.data));
            }
        },
        ready: function () {
            this.loadData();


        },
        beforeDestroy: function () {
            clearInterval(this.interval);
        }


    };
</script>

<style scoped>

</style>